export const PACKAGES = [
  {
    id: "mission",
    name: "MISSION",
    price: "od 2 490 Kč / osoba",
    tagline: "Jeden den. Žádný nocleh. Plná mise.",
    duration: "4–6 hodin",
    features: [
      "Mission Ještěd — outdoorová týmová mise",
      "Kompletní organizace a instruktoři",
      "Transport v místě akce",
      "Mission Pack (mapa, výstroj, instrukce)",
      "Checkpointy a týmové úkoly",
      "Finish drink na Ještědu",
      "Fotografie z akce",
      "Závěrečné vyhlášení výsledků",
    ],
    popular: false,
    testId: "package-card-mission",
  },
  {
    id: "mission24",
    name: "MISSION 24",
    price: "od 4 990 Kč / osoba",
    minPrice: "minimální cena akce 129 000 Kč",
    tagline: "24 hodin. Mise, nocleh, večeře i privátní party.",
    duration: "24 hodin",
    features: [
      "Mission Ještěd — outdoorová týmová mise",
      "1 noc v ubytování pro celý tým",
      "Doprava v místě akce",
      "Lunch / snack během dne",
      "Finish drink na Ještědu",
      "Večeře pro celý tým",
      "Soukromý Warehouse jen pro vaši firmu",
      "DJ a bar na večer",
      "Fotograf po celou akci",
      "Snídaně",
    ],
    popular: true,
    testId: "package-card-mission24",
  },
  {
    id: "mission-weekend",
    name: "MISSION WEEKEND",
    price: "od 6 490 Kč / osoba",
    tagline: "Dvě noci. Mise, druhý program, velká party.",
    duration: "2 noci",
    features: [
      "Mission Ještěd — outdoorová týmová mise",
      "2 noci ubytování",
      "Druhý program navíc (indoor/outdoor)",
      "Catering po celou dobu",
      "Private Warehouse party",
      "DJ a bar",
      "Foto i video z akce",
      "2× snídaně",
    ],
    popular: false,
    testId: "package-card-mission-weekend",
  },
];

export const PRICE_TABLE_24 = [
  { people: 20, price: "129 000 Kč" },
  { people: 30, price: "169 000 Kč" },
  { people: 40, price: "209 000 Kč" },
  { people: 50, price: "249 000 Kč" },
];

export const PRICE_NOTE =
  "Ceny jsou orientační. Finální nabídka závisí na termínu, počtu účastníků a konfiguraci programu. Nezávaznou kalkulaci připravíme na míru.";

export const price24For = (n) => (n <= 20 ? 129000 : 129000 + (n - 20) * 4000);

export const fmtCzk = (n) => `${Math.round(n).toLocaleString("cs-CZ").replace(/ /g, " ")} Kč`;
